import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import AddHomePageSliderComponent from '../components/AddHomePageSliderComponent';
import HeaderComponent from '../components/HeaderComponent';

class AddHomePageSliderPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <AddHomePageSliderComponent />
            </div>
        );
    }
}

export default AddHomePageSliderPage;